import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { BaseComponent } from '@shared/components/base.component';
import { NotificationsDropdownService } from '@shared/components/header/header-desktop/components/notifications-dropdown/notifications-dropdown.service';
import { Notification } from '@shared/models/notification.model';
import { Response } from '@shared/models/response.model';
import { Config } from '@shared/config';
import { RoutesPath } from '@shared/routes-path';
import { interval } from 'rxjs';

@Component({
  selector: 'app-notifications-dropdown',
  templateUrl: './notifications-dropdown.component.html',
  styleUrls: ['./notifications-dropdown.component.scss'],
})
export class NotificationsDropdownComponent extends BaseComponent implements OnInit {
  notificationsSeen: Notification[] = [];
  notificationsUnseen: Notification[] = [];
  loading: boolean = false;
  clickedNotification: Notification;
  @Output() closeNotificationEmitter: EventEmitter<any> = new EventEmitter();
  @Output() getNotificationsStatisticsEmitter: EventEmitter<any> = new EventEmitter();
  projectsStatus: string[] = ['ended', 'draft', 'verified', 'in-review'];

  constructor(public notificationsService: NotificationsDropdownService) {
    super();
  }

  ngOnInit() {
    this.getNotifications();
    const source = interval(10000);
    const subInterval = source.subscribe((el) => {
      // this.getNotifications(true);
    });
    this.someSubscriptions.add(subInterval);
  }

  markAsReadAndRedirect(notification) {
    if (!notification.is_read) {
      this.clickedNotification = notification;
      notification.isRead(true);
      notification.isReading(true);
      const subMarkAsRead = this.notificationsService
        .markAsRead(notification.id)
        .subscribe((el) => {
          this.getNotifications(true, true);
          this.closeNotification(notification);
          setTimeout(() => {
            this.redirectToNotification(notification);
          });
        }, this.onMarkAsReadAndRedirectError.bind(this));
      this.someSubscriptions.add(subMarkAsRead);
    } else {
      this.redirectToNotification(notification);
    }
  }

  onMarkAsReadAndRedirectError() {
    this.closeNotification(this.clickedNotification);
    this.toast.error(
      this.translate.instant('NOTIFICATIONS.cant_mark_as_read'),
      this.translate.instant('NOTIFICATIONS.notifications_error')
    );
  }

  redirectToNotification(item: Notification) {
    this.closeNotificationAside();
    if (Config.NOTIFICATION_TYPE_ACHIEVEMENT.indexOf(item.type) > -1) {
      this.router.navigate(
        [
          '/' +
            RoutesPath.default.profile +
            '/' +
            item.parameters.user_id +
            '/' +
            RoutesPath.default.profileTabs.summary,
        ],
        { fragment: 'badge' }
      );
    }
    if (
      Config.NOTIFICATION_TYPE_PROJECT.indexOf(item.type) > -1 ||
      Config.NOTIFICATION_TYPE_USER.indexOf(item.type) > -1
    ) {
      this.router.navigate([
        '/projects/' +
          this.getProjectStatus(item.parameters.project_status) +
          '/' +
          item.parameters.project_id,
      ]);
    }
  }

  getProjectStatus(type: number) {
    return this.projectsStatus[type - 1];
  }

  clearAllNotifications() {
    const subClearAllNotifications = this.notificationsService
      .clearAllNotifications()
      .subscribe((el) => {
        this.getNotifications();
        this.closeNotificationEmitter.emit();
      }, this.onClearAllNotificationsError.bind(this));
    this.someSubscriptions.add(subClearAllNotifications);
  }

  onClearAllNotificationsError() {
    this.toast.error(
      this.translate.instant('NOTIFICATIONS.cant_mark_all_as_read'),
      this.translate.instant('NOTIFICATIONS.notifications_error')
    );
  }

  closeNotification(notification: Notification) {
    notification.isReading(false);
    this.closeNotificationEmitter.emit();
  }

  closeNotificationAside() {
    this.closeNotificationEmitter.emit();
  }

  get notificationLength() {
    return this.notificationsUnseen.length + this.notificationsSeen.length > 0;
  }

  getNotifications(isIntervalLoading?: boolean, refresh?: boolean) {
    if (!isIntervalLoading) {
      this.loading = true;
    }

    const subGetNotifications = this.notificationsService
      .getNotifications()
      .subscribe((el: Response<Notification>) => {
        if (
          el.data.data.length !== this.notificationsSeen.length + this.notificationsUnseen.length ||
          refresh
        ) {
          this.notificationsSeen = [];
          this.notificationsUnseen = [];
          el.data.data.map((notification: Notification) => {
            const notificationModel: Notification = new Notification(notification);
            switch (notification.is_read) {
              case true:
                this.notificationsSeen.push(notificationModel);
                break;
              case false:
                this.notificationsUnseen.push(notificationModel);
                break;
            }
            this.notificationLength;
          });
        }
        this.loading = false;
      });
    this.someSubscriptions.add(subGetNotifications);
  }
}
